import { Remirror } from '@remirror/react';
import { LinkContainer } from '../Remirror/Link.Container';
import type { Manager, ProjectNotesEditorOnChange, State } from './interfaces';
import styles from './style/Editor.module.css';

type Props = {
  autoFocus?: boolean;
  className?: string;
  editable?: boolean;
  onChange?: ProjectNotesEditorOnChange;
  manager: Manager;
  state: State;
} & ChildrenProps;

export const ProjectNotesEditorContainer = ({
  autoFocus,
  children,
  className,
  editable = true,
  manager,
  onChange,
  state,
}: Props) => {

  return (
    <Remirror
      classNames={[styles.editor, className]}
      autoFocus={autoFocus}
      editable={editable}
      manager={manager}
      onChange={onChange}
      initialContent={state}>
      <LinkContainer>
        {children}
      </LinkContainer>
    </Remirror>
  );
};